import { Container } from "aurelia-framework";
import { Store } from "aurelia-store";
import { IState } from "./state";

const store: Store<IState> = Container.instance.get(Store) as Store<IState>;

export default store;
